import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

export const NoteReservation = ({ r, onSaved }) => {
  const [note, setNote] = useState(r.note_interne || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/reservations/${r.id}/note`, { note });
      toast.success(note.trim() ? "Note enregistrée" : "Note supprimée");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3" data-testid={`res-note-${r.id}`}>
      <p className="text-xs font-semibold text-slate-700 mb-1">Note interne</p>
      <div className="flex flex-col sm:flex-row gap-2 items-start">
        <Textarea value={note} onChange={(e) => setNote(e.target.value)} maxLength={2000} rows={2} className="text-xs bg-white"
          placeholder="Ex. cause d'un écart de dépôt, échange avec la plateforme…" data-testid={`res-note-input-${r.id}`} />
        <Button size="sm" onClick={save} disabled={busy || note === (r.note_interne || "")} className="bg-emerald-700 hover:bg-emerald-800" data-testid={`res-note-save-${r.id}`}>
          {busy && <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />}Enregistrer
        </Button>
      </div>
    </div>
  );
};
